import { createAsyncThunk } from "@reduxjs/toolkit";
import { SLICE_NAME } from "utils/constants";

import { adminSignInApi } from "./services";

export const adminSignIn = createAsyncThunk(
  `${SLICE_NAME.adminSignInSlice}/adminSignIn`,
  async (body, { rejectWithValue }) => {
    try {
      const response = await adminSignInApi.signIn(body);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getUsersInfo = createAsyncThunk(
  `${SLICE_NAME.adminSignInSlice}/getUsersInfo`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await adminSignInApi.getUserInfo();
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getNotifications = createAsyncThunk(
  `${SLICE_NAME.adminSignInSlice}/getNotifications`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await adminSignInApi.getNotifications();
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const deleteNotification = createAsyncThunk(
  `${SLICE_NAME.adminSignInSlice}/deleteNotification`,
  async (id, { rejectWithValue }) => {
    try {
      const response = await adminSignInApi.deleteNotification(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const readAllNotifications = createAsyncThunk(
  `${SLICE_NAME.adminSignInSlice}/readAllNotifications`,
  async (body, { rejectWithValue }) => {
    try {
      const response = await adminSignInApi.readAllNotifications(body);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
